/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeDialogContext, BaSeTheme } from '@base/react';
import * as React from 'react';
import FormCreateNewClassRoom from '../components/form-new-class-room/form-create-class-room';

export function useManageClass() {
  const { showModal } = React.useContext(BaSeDialogContext);

  const openDialogNewClassRoom = React.useCallback(
    (handleUpdateColumns) => {
      return showModal({
        actions: [],
        size: 'small',
        title: 'Criar turma',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        breakpointDelimiter: 'mobileLarge',
        content: ({ closeModal, emitEvent }) => (
          <FormCreateNewClassRoom
            closeFormNewClass={closeModal}
            handleUpdateColumns={handleUpdateColumns}
          />
        ),
        onChooseAction: (action) => {
          handleUpdateColumns();
        },
        //afterClose: () => {},
      });
    },
    [showModal],
  );

  return {
    openDialogNewClassRoom,
  };
}
